<svg
    xmlns="http://www.w3.org/2000/svg"
    {...$$props}
    width="17"
    height="16"
    fill="none"
    ><path
        fill="#fff"
        fill-rule="evenodd"
        d="M6.607.75h4.5v1.5h-4.5V.75Zm2.25 3.167a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Zm-6.25 4.75a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0Zm4.25-3.061L8.5 8l3.061 3.06-1.06 1.061L7.44 8l3.061-3.06L8.5 5Z"
        clip-rule="evenodd"
    /></svg
>
